module.exports = __webpack_public_path__ + "static/logocolor-2d03ba20c425d893fdb8c209bf474591.svg";